import { NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from '../src/routing/app-routing.module';
import { AppComponent } from '../src/components/home/app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MainPageComponent } from './components/main-page/main-page.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { LoginComponent } from './components/login/login.component';
import { PowerComponent } from './components/power/power.component';
import { FEComponent } from './components/fe/fe.component';
import { WaterDiposalComponent } from './components/water-diposal/water-diposal.component';
import { OilGasComponent } from './components/oil-gas/oil-gas.component';
import { ScenarioComponent } from './components/scenario/scenario.component';
import { FecapacitiesComponent } from '../src/components/fecapacities/fecapacities.component';
import { SafeUrlPipe } from '../src/safe';
import { ActiveStandardsComponent } from '../src/components/active-standards/active-standards.component';
import { WaterStandardsComponent } from '../src/components/water-standards/water-standards.component';
import { MatDialogModule} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
} from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

import { environment } from '../src/environments/environments';
import { AdminComponent } from './components/admin/admin.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FeFlowNetworkComponent } from './components/flow-network/flow-network.component';
import { OilGasTabComponent } from '../src/components/oil-gas-tab/oil-gas-tab.component';
import { CdpComponent } from '../src/components/cdp/cdp.component';
import { FeCorridorSystemsComponent } from './components/fe-corridor-systems/fe-corridor-systems.component';
import { GasPlantMappingComponent } from './components/gas-plant-mapping/gas-plant-mapping.component';
import { GasPlantCapacitiesComponent } from './components/gas-plant-capacities/gas-plant-capacities.component';
import { AlternateCapacityComponent } from './components/alternate-capacity/alternate-capacity.component';
import { CdpCorridorMappingComponent } from './components/cdp-corridor-mapping/cdp-corridor-mapping.component';
import { WaterAdminViewComponent } from './components/water-admin-view/water-admin-view.component';
import { WaterMappingViewComponent } from './components/water-mapping-view/water-mapping-view.component';
import { AlternateWaterCapacityComponent } from './components/alternate-water-capacity/alternate-water-capacity.component';
import { WaterCapacitiesViewComponent } from './components/water-capacities-view/water-capacities-view.component';
import { WaterSubDevArea } from './components/water-sub-dev-area/water-sub-dev-area';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { ChatbotVisualizationComponent } from './components/chatbot-visualization/chatbot-visualization.component';
import { AgGridAngular } from 'ag-grid-angular';
import { HomeDashboardComponent } from './components/home-dashboard/home-dashboard.component';
import { EmbeddedReportComponent } from './components/embedded-report/embedded-report.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainPageComponent,
    LoginComponent,
    PowerComponent,
    FEComponent,
    WaterDiposalComponent,
    OilGasComponent,
    ScenarioComponent,
    FecapacitiesComponent,
    AdminComponent,
    SafeUrlPipe,
    ActiveStandardsComponent,
    WaterStandardsComponent,
    FeFlowNetworkComponent,
    WaterStandardsComponent,
    OilGasTabComponent,
    CdpComponent,
    FeCorridorSystemsComponent,
    GasPlantMappingComponent,
    GasPlantCapacitiesComponent,
    AlternateCapacityComponent,
    CdpCorridorMappingComponent,
    WaterAdminViewComponent,
    WaterMappingViewComponent,
    AlternateWaterCapacityComponent,
    WaterCapacitiesViewComponent,
    WaterSubDevArea,
    ChatbotComponent,
    ChatbotVisualizationComponent, 
    HomeDashboardComponent,
    EmbeddedReportComponent,
  ],
  imports: [
    BrowserModule,
    AgGridAngular,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatNativeDateModule,
    MatDividerModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    HttpClientModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    ScrollingModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      timeOut: 3000,
    }),

    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.root.clientId,
          authority: `https://login.microsoftonline.com/${environment.root.tenantId}`,
          redirectUri: environment.redirectUri,
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: true,
        },
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['user.read'],
        },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.read']],
          [environment.WebApiURL, environment.root.apiScope],
          [environment.chatbotUrl, environment.root.apiScope],


        ]),
      }
    ),
  ],
  providers: [
    MsalService,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalGuard,
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
